import React from 'react';
import { Modal, Button, Spinner, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface ConfirmDialogProps {
  show: boolean;
  title: string;
  message: string;
  error?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'primary' | 'warning';
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  show,
  title,
  message,
  error,
  confirmLabel,
  cancelLabel,
  variant = 'danger',
  loading = false,
  onCancel,
  onConfirm,
}) => {
  const { t: tc } = useTranslation('common');

  return (
    <Modal show={show} onHide={onCancel} centered backdrop="static" keyboard={!loading}>
      <Modal.Header closeButton={!loading} closeLabel={tc('buttons.close')} className="an-section-divider">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">{message}</p>
        {error && <Alert variant="danger" className="mt-3 mb-0" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{error}</Alert>}
      </Modal.Body>
      <Modal.Footer className="an-section-divider">
        <Button variant="secondary" onClick={onCancel} disabled={loading}>
          {cancelLabel || tc('buttons.cancel')}
        </Button>
        <Button variant={variant} onClick={onConfirm} disabled={loading}>
          {loading ? <Spinner size="sm" /> : (confirmLabel || tc('buttons.confirm'))}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDialog;
